__turbopack_context__.v({
  "animateHorizontal": "tabs-module__vEcGJW__animateHorizontal",
  "animateList": "tabs-module__vEcGJW__animateList",
  "animateMenu": "tabs-module__vEcGJW__animateMenu",
  "content": "tabs-module__vEcGJW__content",
  "css-0": "tabs-module__vEcGJW__css-0",
  "css-12": "tabs-module__vEcGJW__css-12",
  "css-13": "tabs-module__vEcGJW__css-13",
  "css-16": "tabs-module__vEcGJW__css-16",
  "current": "tabs-module__vEcGJW__current",
  "header": "tabs-module__vEcGJW__header",
  "headers": "tabs-module__vEcGJW__headers",
  "horizontal": "tabs-module__vEcGJW__horizontal",
  "vertical": "tabs-module__vEcGJW__vertical",
});
